import React, { useState } from 'react';
import {
    IconButton,
    Typography,
    Button,
    Paper,
    Grid
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { smallScreenWidth } from '../constants/AppConstants';
import ServerSideAutoCompletev2 from '../functions/ServerSideAutoCompletev2'
import AutocompleteDropDown from '../components/AutocompleteDropdown'
import fetchFromAthena from '../functions/FetchFromAthena'
import LoadingButton from '../components/LoadingButton'
import ReactTable from '../components/ReactTable';

import { useLp51Cols } from '../hooks/EmployeeCols';

const defaultHeaders = {
    company: null,
    employee: null
}

export default function Lp51(props) {
    const { credentials } = props.fetchInitialData
    const [data, setData] = useState(null)
    const [headers, setHeaders] = useState(defaultHeaders)
    const [clearHeader, setClearHeader] = useState(false)
    const [isLoading, setLoading] = React.useState(false)
    const lp51Cols = useLp51Cols();

    const handleSubmit = async () => {
        if (!headers.employee || !headers.company) {
            props.createSnack('Company and Employee are required', 'warning', 3000)
            return
        }
        setLoading(true)

        const data = await fetchFromAthena({
            queryName: 'lp51_loa',
            headers: {
                company: headers.company,
                employee: headers.employee
            },
            accessToken: credentials.user.accessToken,
            credentials: credentials
        }).then(results => {
            return results
        })
        setData(data)
        setLoading(false)
    }

    return (
        <div style={{ padding: '1.5rem 0.5rem' }}>
            <IconButton
                style={{ borderRadius: '5px', position: 'absolute' }}
                size="small"
                onClick={() => props.history.push('/')}
                aria-label="delete"
            >
                <ArrowBackIcon />
                {props.fetchInitialData.credentials.appWidth > smallScreenWidth && 'Dashboard'}
            </IconButton>
            <Typography variant="h5" style={{ textAlign: 'center' }}>
                LP51
            </Typography>

            <div style={{ margin: '1rem' }}>
                <Paper
                    elevation={0}
                    style={{ marginTop: '2rem', width: '100%', padding: '1rem' }}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} style={{ position: 'relative' }}>
                            <div style={{ margin: '0 1rem 0 0' }}>
                                <Grid
                                    container
                                    alignContent='center'
                                    alignItems='flex-start'
                                    spacing={3}
                                >
                                    <Grid item>
                                        <AutocompleteDropDown
                                            {...props}
                                            id={'company'}
                                            name={'company'}
                                            width='160px'
                                            key={`company-${clearHeader}`}
                                            required={true}
                                            variant='standard'
                                            label={'Company'}
                                            value={headers.company}
                                            category={'company'}
                                            screen={'employee'}
                                            onChange={val => setHeaders({ ...headers, company: val ? val.key_value : null })}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <ServerSideAutoCompletev2
                                            disabled={!headers.company}
                                            required={true}
                                            key={`employee-${clearHeader}`}
                                            id='employee'
                                            width='320px'
                                            label='Employee'
                                            accessToken={credentials.user.accessToken}
                                            error='No Employee found'
                                            variant='standard'
                                            handleChange={(id, hit) => {
                                                setHeaders({ ...headers, employee: id ? id : null })
                                            }}
                                            credentials={credentials}
                                            apiResource='autocomplete-sql'
                                            secondaryParams={{
                                                limit: 100,
                                                company: headers.company
                                            }}
                                            dontOpenOnFocus
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                        </Grid>
                        <div style={{ marginTop: '1rem' }}>
                            <LoadingButton
                                disabled={!headers.company || !headers.employee}
                                label='Submit'
                                isLoading={isLoading}
                                color='primaryVLButton'
                                fn={() => handleSubmit(headers.employee)}
                            />
                            {!!(headers.company || headers.employee) && (
                                <Button
                                    onClick={() => {
                                        setClearHeader(!clearHeader)
                                        setHeaders(defaultHeaders)
                                    }}
                                    style={{ marginLeft: '0.5rem' }}
                                >
                                    Clear
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Paper>
                {!!data && (
                    <div style={{ marginTop: '1rem' }}>
                        <ReactTable isLoading={isLoading} cols={lp51Cols} data={data} />
                    </div>
                )}

            </div>
        </div>
    );
}
